"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldPrintReceipt = void 0;
const shouldPrintReceipt = (response) => {
    if (!('_processor' in response)) {
        return false;
    }
    const logLine = response._processor.logs.join('\n').toLocaleLowerCase();
    const isCancelled = logLine.includes('cardholder pressed cancel');
    if (response.isApproved) {
        return true;
    }
    else {
        return !isCancelled;
    }
};
exports.shouldPrintReceipt = shouldPrintReceipt;
//# sourceMappingURL=shouldPrintReceipt.js.map